export var TransactionOperation;
(function (TransactionOperation) {
    TransactionOperation["Credit"] = "Credit";
    TransactionOperation["Debit"] = "Debit";
})(TransactionOperation || (TransactionOperation = {}));
export var CounterpartyRef;
(function (CounterpartyRef) {
    CounterpartyRef["Investor"] = "investor";
    CounterpartyRef["Contact"] = "contact";
    CounterpartyRef["Asset"] = "asset";
    CounterpartyRef["Vehicle"] = "vehicle";
})(CounterpartyRef || (CounterpartyRef = {}));
//# sourceMappingURL=index.js.map